import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ActionModal } from "@components";
import {
  ENROLMENT_STEP,
  ENROLMENT_STEP_STATUS,
  useEnrolmentStatusContext,
} from "@contexts/EnrolmentStatusContext";
import { Routes } from "@utils";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string | React.ReactNode;
  nextStep?: ENROLMENT_STEP;
  nextStepStatus?: ENROLMENT_STEP_STATUS;
}

export const ActionBlockModal: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  description,
  nextStep,
  nextStepStatus,
}) => {
  const navigate = useNavigate();
  const { setCurrentStep, setCurrentStepStatus, getEnrolmentStatus } =
    useEnrolmentStatusContext();

  const handleVolverAlInicio = useCallback(() => {
    onClose();
    navigate(Routes.SOLICITUDES);
  }, [onClose, navigate]);

  const handleTryAnotherMethod = useCallback(async () => {
    onClose();
    if (nextStep && nextStepStatus) {
      setCurrentStep(nextStep);
      setCurrentStepStatus(nextStepStatus);
      return;
    }
    await getEnrolmentStatus();
  }, [
    onClose,
    nextStep,
    nextStepStatus,
    getEnrolmentStatus,
    setCurrentStep,
    setCurrentStepStatus,
  ]);

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={handleTryAnotherMethod}
      title={title}
      description={description}
      secondaryButton={{
        label: "Volver al inicio",
        onClick: handleVolverAlInicio,
      }}
      primaryButton={{
        label: "Probar otro método",
        onClick: handleTryAnotherMethod,
      }}
    />
  );
};
